import { Card, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../shared/stores/RootStore";
import { CustomDialog } from "../../shared/views/CustomDialog";
import { t } from "i18next";

const i18prefix = "home:campaignSelection";

const CampaignSelectionModalBase: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { campaignStore } = useStores();

  return (
    <CustomDialog
      size="sm"
      header={t(`${i18prefix}.defaultButton`)}
      onClose={onClose}
    >
      <Stack>
        {campaignStore.campaigns.map((campaign) => {
          const createdAt = new Date(campaign.createdAt);
          return (
            <Card.Root
              key={campaign.id}
              p={3}
              variant={"subtle"}
              cursor={"pointer"}
              _hover={{ bgColor: "gray.200" }}
              onClick={() => {
                campaignStore.setSelected(campaign.id);
                onClose();
              }}
            >
              <Stack gap={0}>
                <Text fontWeight={"semibold"}>{campaign.name}</Text>
                <Text fontSize={"xs"}>
                  {t(`${i18prefix}.createdAt`, {
                    date: createdAt.toDateString(),
                  })}
                </Text>
              </Stack>
            </Card.Root>
          );
        })}
      </Stack>
    </CustomDialog>
  );
};

export const CampaignSelectionModal = observer(CampaignSelectionModalBase);
